import * as types from "./mutations-types";

export default {
    [types.SET_LIST_TOTAL_YEAR](state, list_total_year) {
        state.list_total_year = list_total_year;
    }
};